import React from "react";
import Modal from "react-modal";

const PopupModalList = ({
  isOpen,
  onRequestClose,
  title,
  message,
  image,
  who,
  image2,
}) => {
  return (
    <>
      {who === "list" && (
        <Modal
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          ariaHideApp={false}
          className="flex items-center justify-center transition-transform transform duration-300 ease-in-out w-full"
          overlayClassName="fixed inset-0 bg-white bg-opacity-30 flex items-center justify-center">
          <div className="bg-white p-6 rounded-xl shadow-lg w-[700px] h-[500px] relative">
            {/* Close Icon in the Top Right */}
            <button
              onClick={onRequestClose}
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 transition duration-200 ease-in-out">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Title */}
            <h2 className="text-2xl font-bold text-center mb-4">{title}</h2>

            {/* Image Container for Side-by-Side Layout */}
            <div className="flex justify-center mb-4">
              <div>
                <img
                  src={image}
                  alt="Text Demo Image"
                  className="w-[300px] pt-20 object-cover rounded-lg"
                />
              </div>

              <img
                src={image2}
                alt="Text Demo Image"
                className="w-[300px] object-cover rounded-lg"
              />
            </div>

            {/* Message */}
            <p className="mt-2 text-center">{message}</p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PopupModalList;
